import { render, staticRenderFns } from "./Bemvindo.vue?vue&type=template&id=53ada0c9&scoped=true&"
import script from "./Bemvindo.vue?vue&type=script&lang=js&"
export * from "./Bemvindo.vue?vue&type=script&lang=js&"
import style0 from "./Bemvindo.vue?vue&type=style&index=0&id=53ada0c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ada0c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
